export const DOMAIN = 'SettingsScreen';
